CCL.productDetails = {
  autoload: [
    ['enableAddToCard', $('.flavor-wrap.selectable-wrap').length > 0]
  ],

  enableAddToCard() {
    // $('.general-add-to-cart-btn').attr('disabled', 'disabled');
    // const $activeElements = $('.flavor-wrap.selectable-wrap').find('.active');
    // const toDisableButton = $('#hideAddToCartButton').val();
    // if ($activeElements.length && !toDisableButton) {
    //   $('.general-add-to-cart-btn').removeAttr('disabled');
    // }
  }
};



// WEBPACK FOOTER //
// ./src/app/components/c-product-details/product-details.js